// extracted by mini-css-extract-plugin
export default {"container":"results-table_container__OCmB7","thContentWrapper":"results-table_thContentWrapper__w-YQ+","td":"results-table_td__lgwmi"};